import React from 'react';
import PropTypes from 'prop-types';
import { computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import Skeleton from '@material-ui/lab/Skeleton';

import FormField from './FormField';
import Technology from '../../api/Technology';
import { FormStepContext } from "./FormStep";
import Factory from "../../api/Factory";


@observer
class TechnologyFormField extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    fullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
  };
  static defaultProps = {
    fullWidth: false,
    disabled: false,
    onChange: null,
  };

  static contextType = FormStepContext;

  @observable technologies = null;
  @observable factories = null;

  async componentDidMount() {
    const selectedTechnologies = this.instance.technologies.sort();
    if (JSON.stringify(selectedTechnologies) !== JSON.stringify([...this.instance.technologies])) {
      this.instance.technologies.replace(selectedTechnologies);
    }
    this.technologies = await Technology.getList({});
    this.factories = await Factory.getList({});
  }

  get instance() {
    return this.context.instance;
  }

  @computed get validTechnologyIds() {
    const validTechnologyIds = [];
    for (const factory of this.factories) {
      if (this.instance.factories.map(factoryId => parseInt(factoryId)).includes(factory.id)) {
        validTechnologyIds.push(...factory.technologies);
      }
    }
    return validTechnologyIds;
  }

  @computed get options() {
    const options = [];
    const pushOption = (technologyIds, label) => {
      const filteredTechnologyIds = technologyIds.filter(
        technologyId => this.validTechnologyIds.includes(technologyId)
      );
      if (filteredTechnologyIds.length > 0) {
        technologyIds.sort();
        options.push([technologyIds, label]);
      }
    };
    pushOption(this.technologies.map(technology => technology.name), 'All');
    for (const { value, display_name } of Technology.fieldsData.family.choices) {
      pushOption(
        this.technologies.filter(technology => technology.family === value).map(technology => technology.name),
        display_name,
      );
      if (this.instance.isReducedScopeSimulation) {
        for (const technology of this.technologies.filter(technology => technology.family === value)) {
          pushOption([technology.name], `                ${technology}`);
        }
      }
    }
    const selectedTechnologies = this.instance.technologies;
    const selectedOptions = options.filter(
      ([technologies, label]) => JSON.stringify(selectedTechnologies) === JSON.stringify(technologies)
    );
    if (selectedOptions.length === 0) {
      pushOption(selectedTechnologies, selectedTechnologies.join(', '));
    }
    return options;
  }

  render() {
    if (this.technologies === null || this.factories === null || Technology.fieldsData === null) {
      return <Skeleton variant="rect" height={55} />;
    }
    const { name, fullWidth, disabled, onChange } = this.props;
    return (
      <FormField
        name={name}
        options={this.options}
        variant="outlined"
        fullWidth={fullWidth}
        disabled={disabled}
        serializer={value => value.join(',')}
        deserializer={value => value.split(',')}
        onChange={onChange}
      />
    );
  }
}


export default TechnologyFormField;
